import AbstractAsset from '@/editor/assets/abstract.asset'
import { DEFAULT_DURATION } from '@/etc/consts'

export default class AdjustmentAsset extends AbstractAsset {
  constructor(uuid) {
    super(uuid)
    this._type = 'adjustment'
    // No transform props; this is a non-rendering clip that hosts effects over time.
    this._props = {}
    this._lastProps = {}
  }

  get resizable() { return true }

  color() {
    // Distinct “utility layer” color for timeline blocks
    return '#3b82f6'
  }

  loadFromFile() {
    return new Promise((resolve) => {
      this._asset.meta.name = 'Adjustment Layer'
      this._asset.meta.duration = DEFAULT_DURATION
      this._asset.ready = true
      this.emit('ready')
      resolve()
    })
  }

  icon() {
    return ['fas', 'layer-group']
  }

  updateFrame(time, localTime, frame) {
    // Use base implementation for time gating; return props for effects (usually empty).
    return super.updateFrame(time, localTime, frame)
  }
}


